export default class ElementModel {
    idNElemento: number | null;
    fkNSupervisor: number | null;
    fkNTipoElemento: number | null;
    fkNAgrupacionElemento: number | null;
    fldTNombre: string | null;
    fldBVisibleEnPortada: boolean | null;
    fldBActivo: boolean | null;

    constructor() {
        this.idNElemento= null;
        this.fkNSupervisor= null;
        this.fkNTipoElemento= null;
        this.fkNAgrupacionElemento= null;
        this.fldTNombre= null;
        this.fldBVisibleEnPortada= null;
        this.fldBActivo= null;
    }
}